import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers.js';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 32 32', className: className, children: _jsx("g", { children: _jsx("line", { x1: '7', x2: '25', y1: '16', y2: '16', stroke: fillColor, strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }) }) }));
});
export default React.memo(Icon);
